export const getPropsByAction = (action, type, redirect) => {
  const actionSubject = type === "PDP" ? "development goal" : "objective";
  switch (action) {
    case "Cancel":
      return {
        heading: `Cancel your ${actionSubject}`,
        message: "Please enter a cancellation reason below for your line manager to see.",
        inputName: "currentFeedback",
        confirmText: "Confirm cancellation",
        status: "cancelled",
        navTo: `/my-objectives/${type || "objectives"}`,
        toast: {
          success: `Your ${actionSubject} has been cancelled.`,
          error: `There was a problem updating ${actionSubject}. Please try again.`,
        },
        focusOnClose: "cancelObjectiveBtn",
      };
    case "LMCancel":
      return {
        heading: `Cancel ${actionSubject}`,
        message: `The ${actionSubject} will be marked as cancelled. This cannot be undone.`,
        message2:
          "Please give a reason for cancelling the objective, for example this does not align with the wider team.",
        inputName: "currentFeedback",
        confirmText: "Confirm cancellation",
        status: "cancelled",
        navTo: redirect,
        toast: {
          success: `You have cancelled this ${actionSubject}.`,
          error: `There was a problem cancelling this ${actionSubject}. Please try again.`,
        },
        focusOnClose: "lmCancelBtn",
      };
    case "RejectObjective":
      return {
        heading: `Reject ${actionSubject}`,
        message: `The ${actionSubject} will be marked as ‘review required’. The team member can then decide to cancel the ${actionSubject} or they can edit it and send it back to you for approval.`,
        message2: "Please enter a rejection reason below.",
        inputName: "currentFeedback",
        confirmText: "Confirm rejection",
        status: "review required",
        navTo: redirect,
        toast: {
          success: `You have rejected this ${actionSubject}.`,
          error: `There was a problem rejecting this ${actionSubject}. Please try again.`,
        },
        focusOnClose: "rejectBtn",
      };
    case "RejectCompletion":
      return {
        heading: "Reject completion",
        message: `This ${actionSubject} will be returned to your team member and not marked as complete.`,
        message2: "Please enter reason for rejecting the completion below.",
        inputName: "currentFeedback",
        confirmText: "Confirm rejection",
        status: "approved",
        navTo: redirect,
        toast: {
          success: `You have returned this ${actionSubject} to your employee.`,
          error: `There was a problem rejecting the completion of this ${actionSubject}. Please try again.`,
        },
        focusOnClose: "rejectBtn",
      };
    default:
      return {};
  }
};
